import { isBrowser } from './dom.esm.js';

function getUserAgentBrowser(navigator) {
  var ua = navigator.userAgent,
      vendor = navigator.vendor;
  var android = /(android)/i.test(ua);

  switch (true) {
    case /CriOS/.test(ua):
      return 'Chrome for iOS';

    case /Edg\//.test(ua):
      return 'Edge';

    case android && /Silk\//.test(ua):
      return 'Silk';

    case /Chrome/.test(ua) && /Google Inc/.test(vendor):
      return 'Chrome';

    case /Firefox\/\d+\.\d+$/.test(ua):
      return 'Firefox';

    case android:
      return 'AOSP';

    case /MSIE|Trident/.test(ua):
      return 'IE';

    case /Safari/.test(navigator.userAgent) && /Apple Computer/.test(ua):
      return 'Safari';

    case /AppleWebKit/.test(ua):
      return 'WebKit';

    default:
      return null;
  }
}
function detectBrowser(browser) {
  if (!isBrowser) return false;
  return getUserAgentBrowser(window.navigator) === browser;
}

export { detectBrowser };
//# sourceMappingURL=user-agent.esm.js.map
